import { FC, Fragment, PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSupabaseAuth } from "../supabase/SupabaseContext";

// Gates on two things: a session (else -> /login) and a claimed roster row
// (else -> /signup, since a signed-in Supabase Auth user might not have
// picked their name yet).
const RequireAuth: FC<PropsWithChildren> = ({ children }) => {
  const { session, member, isLoading } = useSupabaseAuth();
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!member) {
    return <Navigate to="/signup" replace />;
  }

  return <Fragment>{children}</Fragment>;
};

export default RequireAuth;
